import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { reloadCompany } from 'common/actions/company';
import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import connect from 'common/core/connect';
import Link from 'common/Link';
import Tappable from 'common/Tappable';
import UppercaseHeader from 'common/UppercaseHeader';
import hasPermission from 'common/util/hasPermission';
import withContexts from 'common/util/withContexts';

import 'css/components/subdomain/admin/AdminDashboard/_AdminJoinTeamNUX.scss';

@connect(null, (dispatch) => ({
  reloadCompany: () => {
    return dispatch(reloadCompany());
  },
}))
@withContexts(
  {
    company: CompanyContext,
    viewer: ViewerContext,
  },
  {
    forwardRef: true,
  }
)
export default class AdminJoinTeamNUX extends Component {
  static propTypes = {
    company: PropTypes.shape({
      subdomain: PropTypes.string,
    }),
  };

  onDismissNUX = () => {
    AJAX.post('/api/nux/dismissInviteTeammatesNUX', {}, (response) => {
      this.props.reloadCompany();
    });
  };

  render() {
    const { company, viewer } = this.props;
    const viewerHasPermission = hasPermission('manageTeammates', company, viewer);

    if (!viewerHasPermission) {
      return null;
    }

    return (
      <div className="adminJoinTeamNUX">
        <div className="content">
          <div className="title">
            <UppercaseHeader className="tip">TIP</UppercaseHeader>
            Canny works best with collaborators - invite your team
          </div>
          <Link to="/admin/settings/team">
            <UppercaseHeader className="link">Invite Team</UppercaseHeader>
          </Link>
        </div>
        <Tappable onTap={this.onDismissNUX}>
          <div className="icon icon-x" />
        </Tappable>
      </div>
    );
  }
}
